(() => {
  'use strict';
  
  const BODY = document.body;
  const sizeGuideOpenButtons = document.querySelectorAll('[data-size-guide]');
  const sizeGuideModal = document.querySelector('#SizeGuideModal');

  if (sizeGuideModal != null) {
    const sizeGuideModalCloseButton = sizeGuideModal.querySelector('.nextdev--size-guide-modal__close button');
    const breedSizeMap = {
      'Chihuahua': 'XS',
      'Pomeranian': 'XS',
      'Maltipoo': 'XS',
      'Pug': 'XS',
      'Yorkshire Terrier': 'XS',
      'Shih Tzu': 'XS',
      'Miniature Dachshund': 'XS',
      'Maltese': 'XS',
      'Pekingese': 'XS',
      'Papillon': 'XS',
      'Miniature Poodle': 'XS',
      'Boston Terrier': 'XS',
      'French Bulldog': 'XS',
      'Dachshund': 'XS',
      'Havanese': 'XS',
      'Jack Russell Terrier': 'XS',
      'Miniature Schnauzer': 'XS',
      'Toy Poodle': 'XS',
      'Other under 20 lbs': 'XS',

      'Cocker Spaniel': 'S',
      'Staffordshire Bull Terrier': 'S',
      'Middelgrote Poedel': 'S',
      'Cavalier King Charles Spaniel': 'S',
      'Beagle': 'S',
      'Shiba Inu': 'S',
      'Franse Bulldog': 'S',
      'Teckels': 'S',
      'Corgi': 'S',
      'Australian Cattle Dog': 'S',
      'Australian Shepherd': 'S',
      'Basset Hound': 'S',
      'Brittany Spaniel': 'S',
      'Bulldog': 'S',
      'Standard Schnauzer': 'S',
      'Standard Poodle': 'S',
      'Springer Spaniel': 'S',
      'Siberian Husky': 'S',
      'Border Collie': 'S',
      'Pit Bull Terrier / American Staffordshire Terrier': 'S',
      'Shetland Sheepdog': 'S',
      'Other 20-30 lbs': 'S',

      'Labrador': 'L',
      'Boxer': 'L',
      'Large Poodle': 'L',
      'Golden Retriever': 'L',
      'Dalmatian': 'L',
      'Labradoodle': 'L',
      'Border Collie': 'L',
      'Akita Inus': 'L',
      'Other 30-50 lbs': 'L'
    };

    sizeGuideModal.addEventListener('click', (e) => {
      if (e.target === sizeGuideModal) {
        const productModal = document.querySelector('.nextdev--product-modal');
        if (productModal == null) {
          BODY.classList.remove('overflow-hidden');
        }

        sizeGuideModal.classList.remove('active');
      }
    });

    sizeGuideOpenButtons.forEach((sizeGuideOpenButton) => {
      sizeGuideOpenButton.addEventListener('click', (e) => {
        e.preventDefault();

        const productModal = document.querySelector('.nextdev--product-modal');
        if (productModal == null) {
          BODY.classList.add('overflow-hidden');
        }

        sizeGuideModal.classList.add('active');
      });
    });

    sizeGuideModalCloseButton.addEventListener('click', (e) => {
      e.preventDefault();

      const productModal = document.querySelector('.nextdev--product-modal');
      if (productModal == null) {
        BODY.classList.remove('overflow-hidden');
      }

      sizeGuideModal.classList.remove('active');
    });
      
    const customSelects = document.querySelectorAll('select.js-custom-select--size-guide');
    customSelects.forEach(enhanceSelect);

    function enhanceSelect(nativeSelect) {
      const id = nativeSelect.id || `select-${Math.random().toString(36).slice(2)}`;
      nativeSelect.id = id;

      const wrapper = document.createElement('div');
      wrapper.className = 'c-select';
      nativeSelect.after(wrapper);

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'c-select__button';
      button.setAttribute('aria-haspopup', 'listbox');
      button.setAttribute('aria-expanded', 'false');

      const chev = document.createElement('span');
      chev.className = 'c-select__chev';
      chev.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

      const btnText = document.createElement('span');
      btnText.innerHTML = textForValue(nativeSelect);
      button.append(btnText, chev);

      const listbox = document.createElement('ul');
      listbox.className = 'c-select__list';
      listbox.id = `${id}-listbox`;
      listbox.setAttribute('role', 'listbox');
      listbox.setAttribute('tabindex', '-1');
      listbox.hidden = true;

      button.setAttribute('aria-controls', listbox.id);

      const liSearch = document.createElement('li');
      liSearch.classList = 'c-select__search';
      liSearch.setAttribute('role', 'search');
      const searchInput = document.createElement('input');
      searchInput.setAttribute('type', 'text');
      searchInput.setAttribute('name', 'search');
      searchInput.setAttribute('placeholder', 'Search');
      searchInput.addEventListener('keyup', (e) => {
        const val = e.currentTarget.value.trim().toLowerCase();

        sizeGuideModal.querySelectorAll('.c-select__list li[data-value].hidden').forEach((item) => item.classList.remove('hidden'));

        if (val != '') {
          const items = sizeGuideModal.querySelectorAll('.c-select__list li[data-value]:not(.hidden)');
          items.forEach((item) => {
            const itemValue = item.dataset.value;
            const itemValueLowerCase = itemValue.toLowerCase();
              
            if (itemValueLowerCase.includes(val) == false) {
              item.classList.add('hidden');
            }
          });
        }
      });
      const search = document.createElement('div');
      search.append(searchInput);
      liSearch.append(search);
      listbox.append(liSearch);

      const optionEls = [];
      Array.from(nativeSelect.options).forEach((opt, idx) => {
        const optValue = opt.value;

        if (optValue != '') {
          const li = document.createElement('li');
          li.className = 'c-select__option';
          li.setAttribute('role', 'option');
          li.setAttribute('data-value', optValue);
          li.textContent = opt.textContent;

          if (opt.disabled) li.setAttribute('aria-disabled', 'true');
          if (opt.selected) li.setAttribute('aria-selected', 'true');
            
          li.tabIndex = -1;

          li.addEventListener('click', () => selectValue(opt.value, { focusButton: true }));
          li.addEventListener('mousedown', (e) => { e.preventDefault(); });

          optionEls.push(li);
          listbox.appendChild(li);
        }
      });

      wrapper.append(button, listbox);

      nativeSelect.classList.add('c-select--hidden');
      wrapper.prepend(nativeSelect);

      function openList({ focusOption = true } = {}) {
        if (!listbox.hidden) return;
        listbox.hidden = false;
        button.setAttribute('aria-expanded', 'true');

        if (focusOption) {
          const current = listbox.querySelector('[aria-selected="true"]') || nextEnabled(optionEls[0], +1);
          if (current) current.focus();
        }
        document.addEventListener('mousedown', onDocClick);
        document.addEventListener('focusin', onDocFocusOut);
      }

      function closeList({ returnFocus = true } = {}) {
        if (listbox.hidden) return;
        listbox.hidden = true;
        button.setAttribute('aria-expanded', 'false');
        if (returnFocus) button.focus();
        document.removeEventListener('mousedown', onDocClick);
        document.removeEventListener('focusin', onDocFocusOut);
      }

      function selectValue(value, { focusButton = false, fire = true } = {}) {
        nativeSelect.value = value;
        if (fire) nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));

        optionEls.forEach(li => li.setAttribute('aria-selected', String(li.dataset.value === value)));
        btnText.innerHTML = textForValue(nativeSelect);

        closeList({ returnFocus: focusButton });
      }

      function textForValue(sel) {
        const opt = sel.selectedOptions[0] || sel.options[0];
        const image = opt.dataset.image;
        const text = opt ? opt.textContent : '';
        return text;
      }

      function nextEnabled(from, dir) {
        let i = optionEls.indexOf(from);
        do { i = (i + dir + optionEls.length) % optionEls.length; }
        while (optionEls[i] && optionEls[i].getAttribute('aria-disabled') === 'true');
        return optionEls[i] || null;
      }

      button.addEventListener('click', () => {
        if (listbox.hidden) openList(); else closeList({ returnFocus: true });
      });

      button.addEventListener('keydown', (e) => {
        switch (e.key) {
          case 'ArrowDown':
          case 'Down':
            e.preventDefault();
            openList();
            break;
          case 'ArrowUp':
          case 'Up':
            e.preventDefault();
            openList();
            break;
          case 'Enter':
          case ' ':
            e.preventDefault();
            openList();
            break;
          case 'Escape':
            e.preventDefault();
            closeList({ returnFocus: true });
            break;
        }
      });

      listbox.addEventListener('keydown', (e) => {
        const active = document.activeElement.closest('.c-select__option');
        if (!active) return;

        if (e.key === 'ArrowDown' || e.key === 'Down') {
          e.preventDefault();
          nextEnabled(active, +1)?.focus();
        } else if (e.key === 'ArrowUp' || e.key === 'Up') {
          e.preventDefault();
          nextEnabled(active, -1)?.focus();
        } else if (e.key === 'Home') {
          e.preventDefault();
          (optionEls.find(li => li.getAttribute('aria-disabled') !== 'true') || active).focus();
        } else if (e.key === 'End') {
          e.preventDefault();
          [...optionEls].reverse().find(li => li.getAttribute('aria-disabled') !== 'true')?.focus();
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          const value = active.dataset.value;
          if (active.getAttribute('aria-disabled') !== 'true') selectValue(value, { focusButton: true });
        } else if (e.key === 'Escape') {
          e.preventDefault();
          closeList({ returnFocus: true });
        } else if (e.key === 'Tab') {
          closeList({ returnFocus: false });
        }
      });

      function onDocClick(e) {
        if (!wrapper.contains(e.target)) closeList({ returnFocus: false });
      }
      function onDocFocusOut(e) {
        if (!wrapper.contains(e.target)) closeList({ returnFocus: false });
      }

      nativeSelect.addEventListener('change', () => {
        const val = nativeSelect.value;
        optionEls.forEach(li => li.setAttribute('aria-selected', String(li.dataset.value === val)));
        const textValue = textForValue(nativeSelect);
        btnText.innerHTML = textValue;

        sizeGuideModal.querySelectorAll('[data-size]:not(.hidden)').forEach((sizeContent) => sizeContent.classList.add('hidden'));
        sizeGuideModal.querySelectorAll('.name').forEach((name) => name.textContent = textValue);
        let size = breedSizeMap[textForValue(nativeSelect)].toLowerCase();
        if (size == 'xs') {
          sizeGuideModal.querySelector('[data-size="xs"]').classList.remove('hidden');
        } else if (size == 's') {
          sizeGuideModal.querySelector('[data-size="s"]').classList.remove('hidden');
        } else if (size == 'l') {
          sizeGuideModal.querySelector('[data-size="l"]').classList.remove('hidden');
        }
      });
    }
  }
})();
